import { useMutation, gql } from '@apollo/client';
import ReactGA from "react-ga4";

const csMutation = gql`
mutation($payload: JSONObject!) {
  cs(payload: $payload),
}
`;

interface CsEventPayload {
  category: string;
  action: string;
  label?: string;
  [key: string]: unknown;
}

const useCsEvent = function(): (payload: CsEventPayload) => void {
  const [trigger] = useMutation(csMutation, {
    onCompleted: () => {},
    errorPolicy: 'all'
  });
  return (payload: CsEventPayload) => {
    trigger({
      variables: {
        payload: {
          ...payload,
          ua: window?.navigator?.userAgent,
          url: window.location.pathname + window.location.search,
        }
      }
    });
    ReactGA.event({
      category: payload.category,
      action: payload.action,
      label: payload.label,
    });
  };
};

export {
  useCsEvent
};
